import { RULES_DEMOS } from './demos'
import type { RulesSection } from './content'
import './rules.css'

/**
 * One section, rendered identically wherever it appears: heading, then the visual,
 * then the copy. Visual above copy, always — the demo is the explanation and the `lede` is its
 * caption, not the other way round.
 *
 * Shared by the how-to-play screen and the ⓘ sheet on purpose. Two renderers would be two places
 * for the copy order to drift, and the sheet is where most people will actually meet the rules.
 */
export default function RulesSectionBody({ section }: { section: RulesSection }) {
  const Demo = RULES_DEMOS[section.visual]

  return (
    <>
      <h2 className="rules-section__title">{section.title}</h2>
      <Demo />
      <p className="rules-section__lede">{section.lede}</p>
      {section.points && section.points.length > 0 && (
        <ul className="rules-section__points">
          {section.points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      )}
    </>
  )
}
